/* =========================================================
   Brand Corner — theme.js
   Vanilla JS replacing the original React state/interactivity.
   ========================================================= */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     Header scroll state
  --------------------------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------
     Drawers: mobile menu / search / cart
     Any element with [data-drawer-open="name"] opens
     the element [data-drawer="name"]; [data-drawer-close]
     closes it (or all, if used without a value inside a
     drawer wrapper).
  --------------------------------------------------------- */
  function getDrawer(name) {
    return document.querySelector('[data-drawer="' + name + '"]');
  }

  function lockScroll(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function anyDrawerOpen() {
    return !!document.querySelector('[data-drawer]:not([hidden])');
  }

  function openDrawer(name) {
    var el = getDrawer(name);
    if (!el) return;
    el.hidden = false;
    // trigger reflow for potential transition classes
    void el.offsetWidth;
    el.classList.add('is-open');
    lockScroll(true);

    if (name === 'search') {
      var input = el.querySelector('input[type="text"], input[name="q"]');
      if (input) input.focus();
    }
  }

  function closeDrawer(name) {
    var el = getDrawer(name);
    if (!el) return;
    el.classList.remove('is-open');
    el.hidden = true;
    if (!anyDrawerOpen()) lockScroll(false);
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      openDrawer(openTrigger.getAttribute('data-drawer-open'));
      return;
    }
    var closeTrigger = e.target.closest('[data-drawer-close]');
    if (closeTrigger) {
      e.preventDefault();
      var name = closeTrigger.getAttribute('data-drawer-close');
      if (name) {
        closeDrawer(name);
      } else {
        var wrapper = closeTrigger.closest('[data-drawer]');
        if (wrapper) closeDrawer(wrapper.getAttribute('data-drawer'));
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-drawer]:not([hidden])').forEach(function (el) {
        closeDrawer(el.getAttribute('data-drawer'));
      });
    }
  });

  /* Search popular tag pills -> fill input */
  document.addEventListener('click', function (e) {
    var tag = e.target.closest('[data-search-tag]');
    if (!tag) return;
    var input = document.querySelector('.bc-search-overlay__input');
    if (input) {
      input.value = tag.textContent.trim();
      input.focus();
    }
  });

  /* ---------------------------------------------------------
     Wishlist (client-side, persisted in localStorage since
     Shopify has no native wishlist concept)
  --------------------------------------------------------- */
  var WISHLIST_KEY = 'bc_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (err) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (err) { /* ignore */ }
    updateWishlistBadge();
  }

  function updateWishlistBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', getWishlist().indexOf(id) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    setWishlist(list);
  });

  updateWishlistBadge();

  /* ---------------------------------------------------------
     Ajax cart: add to cart from product cards
  --------------------------------------------------------- */
  function fetchCartJSON() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function renderCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-count-inline]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .catch(function () { return null; });
  }

  /* Simplest robust approach: reload the cart drawer markup via
     the theme's cart section rendered as a section, falling back
     to a full cart.js summary refresh if the section isn't found. */
  function updateCartDrawerUI() {
    fetchCartJSON().then(function (cart) {
      renderCartCount(cart);
      var subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
      subtotalEls.forEach(function (el) {
        el.textContent = formatMoney(cart.total_price);
      });
      // Re-render items list minimally
      var itemsWrap = document.querySelector('[data-cart-items]');
      if (itemsWrap) {
        if (cart.item_count === 0) {
          itemsWrap.innerHTML = '<p class="bc-cart-drawer__empty">Your cart is empty.</p>';
        } else {
          var html = '<ul class="bc-cart-list">';
          cart.items.forEach(function (item, i) {
            html += '' +
              '<li class="bc-cart-item" data-cart-line="' + (i + 1) + '">' +
                '<img class="bc-cart-item__img" src="' + item.image + '&width=200" alt="' + escapeHtml(item.product_title) + '" width="96" height="128">' +
                '<div class="bc-cart-item__body">' +
                  '<div>' +
                    '<p class="display bc-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
                    '<p class="bc-cart-item__price">' + formatMoney(item.final_price) + '</p>' +
                  '</div>' +
                  '<div class="bc-cart-item__controls">' +
                    '<div class="bc-qty-stepper">' +
                      '<button type="button" class="bc-qty-stepper__btn" data-cart-qty-decrease data-line="' + (i + 1) + '">&minus;</button>' +
                      '<span class="bc-qty-stepper__value">' + item.quantity + '</span>' +
                      '<button type="button" class="bc-qty-stepper__btn" data-cart-qty-increase data-line="' + (i + 1) + '">+</button>' +
                    '</div>' +
                    '<button type="button" class="bc-cart-item__remove" data-cart-remove data-line="' + (i + 1) + '">Премахни</button>' +
                  '</div>' +
                '</div>' +
              '</li>';
          });
          html += '</ul>';
          itemsWrap.innerHTML = html;
        }
      }
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (!addBtn || addBtn.disabled) return;
    e.preventDefault();
    var variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = addBtn.textContent;
    addBtn.textContent = 'Adding...';
    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        addBtn.textContent = 'Добавено';
        updateCartDrawerUI();
        openDrawer('cart');
        setTimeout(function () {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }, 1200);
      })
      .catch(function () {
        addBtn.textContent = originalText;
        addBtn.disabled = false;
      });
  });

  /* Cart drawer quantity +/- and remove, delegated (works after re-render) */
  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-cart-qty-increase]');
    var decBtn = e.target.closest('[data-cart-qty-decrease]');
    var rmBtn = e.target.closest('[data-cart-remove]');
    var btn = incBtn || decBtn || rmBtn;
    if (!btn) return;
    e.preventDefault();

    var line = parseInt(btn.getAttribute('data-line'), 10);
    var valueEl = btn.closest('.bc-cart-item') ? btn.closest('.bc-cart-item').querySelector('.bc-qty-stepper__value') : null;
    var currentQty = valueEl ? parseInt(valueEl.textContent, 10) : null;

    var newQty;
    if (rmBtn) {
      newQty = 0;
    } else if (incBtn) {
      newQty = (currentQty || 0) + 1;
    } else {
      newQty = Math.max(0, (currentQty || 1) - 1);
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        updateCartDrawerUI();
      });
  });

  /* ---------------------------------------------------------
     Product page: gallery thumbnail switch
  --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var full = thumb.getAttribute('data-full');
    var mainImg = document.querySelector('[data-product-main-image] img');
    if (full && mainImg) {
      mainImg.src = full;
    }
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

})();
